import React, {useEffect} from "react";
import {firebaseConfig} from "repository/firebaseUtils";
import "firebase/compat/auth";
import firebase from "firebase/compat/app";
import {Navigate} from "react-router-dom";
import {useAuth} from "hooks/useAuth";
import Spinner from "@awsui/components-react/spinner";
import { useMutation } from "react-query";
import User from "model/User";
import signOut from "api/signOut";

// Fetch the firebase object
firebase.initializeApp(firebaseConfig);

const SignOutPage: React.FC = () => {
    const [{isSignedIn, user}, dispatch] = useAuth();

    const {
        mutateAsync: signOutMutation,
    } = useMutation((signedInUser: User) => signOut(signedInUser?.token));

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (!isSignedIn || !user) return;
            // Sequence the sign-out so each step completes before the next.
            // Swallow errors so one failure doesn't leave the user stuck signed-in.
            try { await signOutMutation(user); } catch { /* continue */ }
            try { await firebase.auth().signOut(); } catch { /* continue */ }
            if (!cancelled) {
                dispatch({
                    user: undefined,
                    isSignedIn: false,
                    isAdmin: false,
                    league: undefined
                });
            }
        })();
        return () => { cancelled = true; };
    }, [isSignedIn, user, dispatch, signOutMutation]);


    return isSignedIn ? (
        <Spinner size="big" />
    ) : (
        <Navigate to={"/"}/>
    );
};

export default SignOutPage;
